import Highlight from './Highlight';

import { ActionName } from '../types';
export function removeHighlightsActionFactory(highlights: Highlight[]) {
  return () => {
    setTimeout(() => {
      highlights.forEach((highlight) => {
        try {
          return highlight.hideAnnotation();
        } catch (e) {
          console.debug(
            `Error hiding annotation: ${JSON.stringify(highlight, null, 2)}`,
            e,
          );
        }
      });
    }, 1000); // delay a bit to make the UX smoother
  };
}

export default {
  [ActionName.REMOVE_HIGHLIGHTS]: [
    removeHighlightsActionFactory,
    'highlights',
  ] as const,
};
